// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"AppSidebar_sidebar_1HP5v","container":"AppSidebar_container_31ayX","on":"AppSidebar_on_3mMRZ"};